import { getWorkoutExerciseIds } from '@strength/domain-workout';
import { useSetAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import { trpc } from '../../../../trpc/react';
import { exerciseVideoMapAtom } from '../slots/common';
import type { WorkoutWithCycleAndSession } from '../types';

/**
 * Batch-fetches video URLs for all exercises in the block's workouts
 * and syncs the result to the exerciseVideoMapAtom.
 */
export function useBlockExerciseVideos(
  workouts: WorkoutWithCycleAndSession[],
) {
  const setExerciseVideoMap = useSetAtom(exerciseVideoMapAtom);

  const libraryExerciseIds = useMemo(() => {
    const ids = workouts.flatMap((w) => getWorkoutExerciseIds(w));
    return [...new Set(ids)];
  }, [workouts]);

  const { data: exerciseVideosData } =
    trpc.exerciseLibrary.exerciseVideosByIds.useQuery(
      { libraryExerciseIds },
      {
        enabled: libraryExerciseIds.length > 0,
      },
    );

  useEffect(() => {
    if (!exerciseVideosData) {
      setExerciseVideoMap({});
      return;
    }
    const map: Record<string, string> = {};
    for (const { id, videoUrl } of exerciseVideosData) {
      if (videoUrl) {
        map[id] = videoUrl;
      }
    }
    setExerciseVideoMap(map);
  }, [exerciseVideosData, setExerciseVideoMap]);
}
